import API from '@/api'
import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
    moment
})

var tempAllClient = []
var tempAllDepartment = []
var tempAllManagedCompanies = []
var tempAllUser = []
var tempAllContractPart = []
var tempAllUserCompanies = []

export default {
    hasSessionToken () {
        return (localStorage.sessionToken !== null && localStorage.sessionToken !== undefined)
    },
    checkIsEmployee () {
        if (localStorage.getItem('currentUserCompany') === null) return false
        const { permissions } = JSON.parse(localStorage.getItem('currentUserCompany'))
        return permissions.isEmployee ?? false
    },
    checkIsMainAccount () {
        if (localStorage.getItem('currentUserCompany') === null) return false
        const { permissions } = JSON.parse(localStorage.getItem('currentUserCompany'))
        return permissions.isMainAccount ?? false
    },
    checkIsManager () {
        if (localStorage.getItem('currentUserCompany') === null) return false
        const { client } = JSON.parse(localStorage.getItem('currentUserCompany'))
        return (client.type === 'manager')
    },
    isPrivate (item) {
        if (item.isMainAccount === true) {
            return (window.getApp.isMainAccount || item.isMainAccount === window.getApp.isMainAccount)
        } else if (item.isEmployee === true) {
            return (window.getApp.isEmployee || item.isEmployee === window.getApp.isEmployee)
        } else if (item.clientOnly === true) {
            return (window.getApp.isEmployee === false || item.isEmployee === window.getApp.isEmployee)
        }
        return true
    },
    isAdmin () {
        if (localStorage.getItem('currentUserCompany') === null) return false
        const { permissions } = JSON.parse(localStorage.getItem('currentUserCompany'))
        return permissions.isAdmin ?? false
    },
    // isEmployee (item) {
    //     return (window.getApp.isEmployee || item.isEmployee === window.getApp.isEmployee)
    // },
    // isMainAccount (item) {
    //     return (window.getApp.isMainAccount || item.isMainAccount === window.getApp.isMainAccount)
    // },
    toggleFullScreen () {
        let doc = window.document
        let docEl = doc.documentElement
        let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen
        let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen
        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            requestFullScreen.call(docEl)
        } else {
            cancelFullScreen.call(doc)
        }
    },
    setItemLocalStorage (key, value) {
        localStorage.setItem(key, value)
    },
    setLocalStorage (data, companies) {
        // rever
        const currentUserCompany = companies[0]
        window.getApp.invalidSession = false
        window.getApp.isEmployee = currentUserCompany.permissions.isEmployee ?? false
        // if (!window.getApp.isEmployee) localStorage.setItem('responsible', JSON.stringify(data.responsible))
        if (companies !== undefined) {
            localStorage.setItem('companies', JSON.stringify(companies))
            if (companies.length > 0) {
                localStorage.setItem('currentUserCompany', JSON.stringify(currentUserCompany))
            }
        }
        localStorage.setItem('isEmployee', window.getApp.isEmployee)
        this.setItemLocalStorage('sessionToken', data.sessionToken)
        localStorage.setItem('profile', JSON.stringify(data))
    },
    clearLocalStorage () {
        tempAllClient = []
        tempAllDepartment = []
        tempAllUser = []
        tempAllContractPart = []
        tempAllUserCompanies = []
        tempAllManagedCompanies = []
        localStorage.clear()
    },
    getObjectValueByPath (obj, path, fallback) {
        // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
        if (obj == null || !path || typeof path !== 'string') return fallback
        if (obj[path] !== undefined) return obj[path]
        path = path.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
        path = path.replace(/^\./, '') // strip a leading dot
        return this.getNestedValue(obj, path.split('.'), fallback)
    },
    getNestedValue (obj, path, fallback) {
        const last = path.length - 1

        if (last < 0) return obj === undefined ? fallback : obj

        for (let i = 0; i < last; i++) {
            if (obj == null) {
                return fallback
            }
            obj = obj[path[i]]
        }

        if (obj == null) return fallback

        return obj[path[last]] === undefined ? fallback : obj[path[last]]
    },
    sleep (ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
    },
    unmask (string) {
        let defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/
        return string ? String(string).replace(new RegExp(defaultDelimiters, 'g'), '') : string
    },
    requestError (responseError) {
        if (responseError.status !== 0) alert('Ocorreu um erro!')
    },
    setClientSortView (sort) {
        localStorage.setItem('clientSort', JSON.stringify(sort))
    },
    setClientSortDemandActiveView (sort) {
        localStorage.setItem('clientSortDemandsActives', JSON.stringify(sort))
    },
    setClientSortDemandCompletedView (sort) {
        localStorage.setItem('clientSortDemandsCompleteds', JSON.stringify(sort))
    },
    setClientSortDemandStandbyView (sort) {
        localStorage.setItem('clientSortDemandsStandbys', JSON.stringify(sort))
    },
    setClientSortContractActiveView (sort) {
        localStorage.setItem('clientSortContractsActives', JSON.stringify(sort))
    },
    setClientSortWorkedHourView (sort) {
        localStorage.setItem('clientSortWorkedHour', JSON.stringify(sort))
    },
    setClientSortUserCompanyView (sort) {
        localStorage.setItem('clientSortUserCompany', JSON.stringify(sort))
    },
    setClientSortContractInactiveView (sort) {
        localStorage.setItem('clientSortContractsInactives', JSON.stringify(sort))
    },
    setnotificationSelected (selected) {
        localStorage.setItem('notificationSelected', JSON.stringify(selected))
    },
    clearClientSortView () {
        localStorage.removeItem('clientSort')
    },
    getAllClient (skip = null, onlyChild = false, onlyManaged = false) {
        let currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
        if (skip == null) {
            skip = 0
            tempAllClient = []
        }
        let endpoint = API.EndPoints.getAllClient
        let params = {
            limit: 100,
            skip: skip,
            parent: currentUserCompany?.parent?.objectId ?? currentUserCompany?.client?.objectId,
            onlyChild,
            notDepartment: true,
            onlyManaged
        }
        return new API(endpoint, params).request().then(response => {
            tempAllClient = tempAllClient.concat(response.data.result.results)
            if (tempAllClient.length < response.data.result.count) {
                return this.getAllClient(skip + 1, onlyChild, onlyManaged)
            }
            return tempAllClient
        }, (e) => {
            this.requestError(e)
        })
    },
    getAllClientTwo (onlyChild = false, skip, type) {
        let currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
        if (skip == null) {
            skip = 0
            tempAllDepartment = []
        }
        let endpoint = API.EndPoints.getAllClient
        let params = {
            limit: 100,
            skip: skip,
            parent: currentUserCompany?.parent?.objectId ?? currentUserCompany?.client?.objectId,
            onlyChild,
            type
        }
        return new API(endpoint, params).request().then(response => {
            tempAllDepartment = tempAllDepartment.concat(response.data.result.results)
            if (tempAllDepartment.length < response.data.result.count) {
                return this.getAllClient(onlyChild, skip + 1, type)
            }
            return tempAllDepartment
        }, (e) => {
            this.requestError(e)
        })
    },
    getAllManagerCompany (skip) {
        let currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
        if (skip == null) {
            skip = 0
            tempAllManagedCompanies = []
        }
        let endpoint = API.EndPoints.getManagerCompany
        const where = {
            managed: { __type: 'Pointer', className: 'Client', objectId: currentUserCompany?.client?.objectId },
            manager: { '$ne': { __type: 'Pointer', className: 'Client', objectId: currentUserCompany?.client?.objectId } }
        }
        let params = {
            limit: 100,
            skip: skip,
            count: true,
            order: 'manager.nameLowerCase',
            where: JSON.stringify(where),
            include: ['manager']
        }
        return new API(endpoint, params).request().then(response => {
            tempAllManagedCompanies = tempAllManagedCompanies.concat(response.data.results)
            if (tempAllManagedCompanies.length < response.data.count) {
                return this.getAllManagerCompany(skip + 1)
            }
            return tempAllManagedCompanies
        }, (e) => {
            this.requestError(e)
        })
    },
    getAllEmployee (clientId, skip) {
        let currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
        if (skip == null) {
            tempAllUser = []
            skip = 0
        }
        let endpoint = API.EndPoints.getUserCompany
        const where = {
            client: { __type: 'Pointer', className: 'Client', objectId: clientId ?? currentUserCompany?.parent?.objectId ?? currentUserCompany?.client?.objectId },
            isActive: true
        }
        const params = {
            limit: 100,
            skip: skip,
            count: true,
            order: 'nameLowerCase',
            where: JSON.stringify(where),
            include: ['user']
        }
        return new API(endpoint, params).request().then(response => {
            tempAllUser = tempAllUser.concat(response.data.results)
            if (tempAllUser.length < response.data.count) {
                return this.getAllEmployee(clientId, skip + 1)
            }
            return tempAllUser
        }, (e) => {
            this.requestError(e)
        })
    },
    getAllContractPart (skip) {
        const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
        const isOrganization = (currentUserCompany.parent.objectId === currentUserCompany.client.objectId)
        if (skip == null) {
            tempAllContractPart = []
            skip = 0
        }
        let endpoint = API.EndPoints.getAllContractPart
        let params = {
            limit: 100,
            skip: skip,
            client: currentUserCompany?.client?.objectId,
            all: isOrganization
        }
        return new API(endpoint, params).request().then(response => {
            tempAllContractPart = tempAllContractPart.concat(response.data.result.items)
            if (tempAllContractPart.length < response.data.result.count) {
                return this.getAllContractPart(skip + 1)
            }

            return this.uniqByKeepLast(tempAllContractPart, part => part.name)
        }, (e) => {
            this.requestError(e)
        })
    },
    getAllUserCompanies (profile, skip) {
        if (skip == null) {
            tempAllUserCompanies = []
            skip = 0
        }
        const endpoint = API.EndPoints.getUserCompany
        const where = {
            user: {
                __type: 'Pointer',
                className: '_User',
                objectId: profile.objectId
            }
        }
        const params = {
            limit: 100,
            skip: skip,
            count: true,
            order: 'createdAt',
            where: JSON.stringify(where),
            include: ['client', 'user']
        }
        return new API(endpoint, params).request().then(response => {
            tempAllUserCompanies = tempAllUserCompanies.concat(response.data.results)
            if (tempAllUserCompanies.length < response.data.count) {
                return this.getAllUserCompanies(profile, skip + 1)
            }

            return this.uniqByKeepLast(tempAllUserCompanies, part => part.objectId)
        }, (e) => {
            this.requestError(e)
        })
    },
    getContractStatusLabel: function (param) {
        const status = {
            1: 'Minutas',
            2: 'Assinaturas',
            3: 'Vigente',
            4: 'Renovação',
            5: 'Rescindido',
            6: 'Extinto'
        }
        return status[param]
    },
    formatContractPart: function (param) {
        if (param === undefined || param.length === 0) return 'Contrato sem partes registradas'
        let part = ''
        for (let index = 0; index < param.length; index++) {
            if (param[index].isMainPart) {
                part = `${param[index].type} - ${param[index].name}`
                return part
            }
        }
    },
    getContractLastDeadline: function (param) {
        if (param === undefined || param.length === 0) return 'Contrato sem prazos registrados'
        param = param.filter(function (deadline) {
            if (deadline.isDone === false) {
                return deadline
            }
        })
        if (param === undefined || param.length === 0) return 'Contrato sem prazos pendentes'
        param = param.reduce(function (a, b) {
            return (a.deadline < b.deadline) ? a : b
        })
        let date = new Date(param.deadline.split('T')[0])
        return `${param.name} - ${Vue.moment(date).format('L')}`
    },
    pad: function (num) {
        return (num >= 10 ? '' : '0') + num
    },
    formatDatetoParse: function (date) {
        return { '__type': 'Date', 'iso': new Date(date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString() }
    },
    uniqByKeepLast: function (data, key) {
        return [
            ...new Map(
                data.map(x => [key(x), x])
            ).values()
        ]
    },
    getCorporateClientId (routeObject, routeName, clientIdCallBack) {
        if (window.getApp.currentCorporateClient !== undefined) return window.getApp.currentCorporateClient
        if (routeObject === routeName) {
            let currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            return currentUserCompany?.parent?.objectId ?? currentUserCompany?.client?.objectId
        } else {
            return clientIdCallBack
        }
    },
    compareArrays (array1, array2) {
        // Check length of both arrays
        // if length not equal then arrays are different
        if (array1.length !== array2.length) {
            return false
        } else {
            // check every element of the two arrays
            for (var i = 0; i < array1.length; i++) {
                if (array1[i] !== array2[i]) {
                    return false
                }
                return true
            }
        }
    },
    objectWithoutTheseAttributesFromObject (array, object) {
        for (let i = array.length - 1; i >= 0; i--) {
            let thisAttributeToDelete = array[i]
            delete object[thisAttributeToDelete]
        };
        return object
    },
    getUserCompany () {
        return JSON.parse(localStorage.getItem('currentUserCompany'))
    },
    lastWednesday () {
        const currentDayOfWeek = moment().day()
        const daysUntilLastWednesday = currentDayOfWeek >= 3 ? currentDayOfWeek - 3 : currentDayOfWeek + 6
        return moment().subtract(daysUntilLastWednesday, 'days')
    },
    isDateBeforeWednesday (dateString) {
        if (dateString === undefined) return false
        const providedDate = moment(dateString).startOf('day')
        const lastWednesday = this.lastWednesday().startOf('day')
        return providedDate.isBefore(lastWednesday)
    },
    normalizeFilename (filename) {
        // Mapeamento de caracteres acentuados para suas versões sem acento
        const accentMap = {
            'á': 'a',
            'à': 'a',
            'ã': 'a',
            'â': 'a',
            'ä': 'a',
            'é': 'e',
            'è': 'e',
            'ê': 'e',
            'ë': 'e',
            'í': 'i',
            'ì': 'i',
            'î': 'i',
            'ï': 'i',
            'ó': 'o',
            'ò': 'o',
            'õ': 'o',
            'ô': 'o',
            'ö': 'o',
            'ú': 'u',
            'ù': 'u',
            'û': 'u',
            'ü': 'u',
            'ç': 'c',
            'ñ': 'n'
        }
        // Função para remover acentos
        function removeAccents (str) {
            return str.split('').map(char => accentMap[char] || char).join('')
        }
        // Remover acentos
        filename = removeAccents(filename)
        // Substituir caracteres especiais (exceto .)
        filename = filename.replace(/[^a-zA-Z0-9. ]/g, '')
        // Trocar espaço por underscore
        filename = filename.replace(/ /g, '_')
        // Trocar . por _ exceto antes da extensão
        const parts = filename.split('.')
        const extension = parts.pop()
        const name = parts.join('_')
        // Colocar em lowercase
        const normalized = name.toLowerCase() + '.' + extension.toLowerCase()
        return normalized
    },
    getFormattedDate (dateFormatted) {
        const dateParts = dateFormatted.split('/')
        const dateNow = new Date()
        dateNow.setDate(dateParts[0])
        dateNow.setMonth(dateParts[1] - 1)
        dateNow.setFullYear(dateParts[2])
        return dateNow.toISOString()
    },
    getContractRoles () {
        let endpoint = API.EndPoints.getContractRoles
        return new API(endpoint, {}).request().then(response => {
            return response.data.result
        }, (e) => {
            this.requestError(e)
        })
    },
    setCorporateClient (objectId) {
        if (objectId === undefined) {
            localStorage.removeItem('currentCorporateClient')
            return
        }
        localStorage.setItem('currentCorporateClient', JSON.stringify({ value: objectId }))
        window.getApp.currentCorporateClient = objectId
        window.dispatchEvent(new Event('storageChange'))
    },
    checkCorporateClient () {
        if (localStorage.getItem('currentCorporateClient') === null) return undefined
        const { value } = JSON.parse(localStorage.getItem('currentCorporateClient'))
        return value
    }
}
